<script>
  import Adsense from 'src/pc/components/Adsense'
  export default {
    extends: Adsense,
    components: {
      Adsense
    }
  }
</script>